import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, mergeMap, Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { LocalStorageService } from 'src/app/core/services/localstorage.service';
import { organisationActions } from 'src/app/core/store/organisation/organisation.actions';
import { userActions } from 'src/app/core/store/userData/userData.actions';
import { LoadingSpinnerModule } from "src/app/shared/design-system/loading-spinner/loading-spinner.module";
import { environment } from 'src/environments/environment';


@Component({
  selector: 'aoe-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatDialogModule,
    LoadingSpinnerModule
  ]
})
export class LoginComponent implements OnInit, OnDestroy {

  public user = new FormControl(null, [Validators.required])
  public pwd = new FormControl(null, [Validators.required])
  public err?: any;

  private readonly subs = new Subscription();

  form!: FormGroup;
  isloading = false;

  constructor(
    private readonly authService: AuthService,
    private readonly fb: FormBuilder,
    private readonly dialogService: DialogService,
    private readonly store: Store,
    private readonly router: Router,
    private readonly localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      login: this.user,
      password: this.pwd,
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  get isFormValid() {
    return this.form.valid;
  }

  onSubmit(): void {
    this.err = undefined;
    if (this.form.valid) {
      this.isloading = true;

      this.subs.add(
        this.authService.getAuthorize(this.form.value).pipe(
          mergeMap(res => this.authService.getToken({ clientId: environment.clientId, clientSecret: environment.clientSecret, code: res.data ?? '', grant_type: 'authorization_code' })),
          catchError(err => { throw err })
        ).subscribe({
          next: authData => {
            this.localStorageService.addData({ 't': authData.data.accessToken });
            this.store.dispatch(userActions['[User]-AddUser'](authData.data));
            if (authData.data.user) {
              this.store.dispatch(organisationActions['[Organisation-API]LoadOrganisation']({ payload: authData.data.user.id }))
            }
            this.router.navigate(['admin']);
            this.dialogService.closeLoginModal();
          },
          error: err => {
            this.isloading = false;
            this.err = err.error.error
          }
        })
      );
    }
  }

  createAccount() {
    this.dialogService.closeLoginModal();
    this.dialogService.openCreateAccountModal();
  }


}
